var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportSection',{attrs:{"columns":3,"data-test-id":"ValueReport__securityCard","title":"Security & Compliance"}},_vm._l((_vm.metrics),function(data,index){return _c('Stat',{key:`security-stat-${index}`,attrs:{"metric":data}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }